export default __webpack_public_path__ + "static/media/Code1.e122ca79.svg";